import franchise from "./franchise";
export default franchise